import { processSteps } from '../data/content';
import Disclosure from './Disclosure';
import SectionCTA from './SectionCTA';
import Surface from './ui/Surface';

export default function ProcessTimeline() {
  return (
    <section className="bg-white py-10 md:py-24" id="process">
      <div className="section-container">
        <div className="max-w-4xl">
          <span className="text-sm font-semibold uppercase tracking-wide text-cam-blue/70">Our Charted Course</span>
          <h2 className="mt-3 text-xl md:text-3xl font-semibold tracking-tight text-slate-900">
            A disciplined framework from first conversation to ongoing guidance.
          </h2>
          <p className="mt-2 text-slate-600">
            Each stage is designed to keep decisions clear and momentum steady so you always know what comes next.
          </p>
        </div>
        <Surface className="mt-10 p-6 md:p-8">
          <ol className="relative grid gap-6 md:grid-cols-5 md:gap-8">
            <span
              aria-hidden="true"
              className="pointer-events-none absolute inset-x-6 top-10 hidden h-px bg-gradient-to-r from-cam-blue/10 via-cam-blue/40 to-cam-blue/10 md:block"
            />
            {processSteps.map((step, index) => (
              <li key={step.label} className="relative flex flex-col gap-4">
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-cam-blue text-white shadow-lg shadow-cam-blue/20">
                    <NauticalIcon index={index} />
                  </span>
                  <span className="text-base font-semibold text-cam-blue md:hidden">{step.label}</span>
                </div>
                <div className="hidden text-base font-semibold text-cam-blue md:block">{step.label}</div>
                <p className="text-sm text-slate-600">{step.description}</p>
              </li>
            ))}
          </ol>
        </Surface>
        <div className="mt-8">
          <Disclosure title="What happens after the discovery meeting?">
            <p>
              We’ll follow up shortly after the discovery meeting with a recap of what we discussed, the next steps, and a brief questionnaire that helps clarify your goals, what’s most important to you, and the level of investment risk you’re comfortable taking.
            </p>
          </Disclosure>
        </div>
        <SectionCTA title="Let’s design a path that fits you." buttonText="Map your plan" />
      </div>
    </section>
  );
}

function NauticalIcon({ index }) {
  const icons = [
    (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="3.5" />
        <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" />
      </svg>
    ),
    (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 3l7 7-7 7-7-7 7-7z" />
        <path d="M12 3v14" />
        <path d="M8 12h8" />
      </svg>
    ),
    (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 3v13" />
        <path d="M7 16h10l-5 5z" />
        <path d="M8 7l4-4 4 4" />
      </svg>
    ),
    (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="6" />
        <path d="M12 6v6l4 2" />
      </svg>
    ),
    (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2v8" />
        <path d="M8 10h8" />
        <path d="M5 14c2 4 12 4 14 0" />
      </svg>
    )
  ];

  return <span className="text-cam-ivory">{icons[index] ?? icons[0]}</span>;
}
